module.exports = __webpack_public_path__ + "img/attestation-icon.8dda301c.png";